import React from 'react';

import clsx from 'clsx';
import { PanelTopHeader } from '@/components/panels/PanelTopHeader/PanelTopHeader';
import { ScrollArea } from '@/components/ui/scroll-area';
import { SettingsSeo } from '../SettingsSeo/SettingsSeo';
import { SettingsSocial } from '../SettingsSocial/SettingsSocial';
import { useAppSelector } from '@/store/hooks';
import { selectSeoSettings } from '@/store/settings/seo/selectors';
import { selectSelectedDomain } from '@/store/domains/selectors';
import { selectCurrentPage, selectSelectedPath } from '@/store/pages/selectors';
import { SettingsScripts } from '../SettingsScripts/SettingsScripts';
import { SettingsFavicon } from '../SettingsFavicon/SettingsFavicon';

interface SettingsProps {
  className: string;
  onSettingsClick?: (elementName: string) => void;
}

export const Settings: React.FC<SettingsProps> = ({ className, onSettingsClick }) => {
  const seoSettings = useAppSelector(selectSeoSettings);
  const selectedDomain = useAppSelector(selectSelectedDomain);
  const selectedPath = useAppSelector(selectSelectedPath);
  const currentPage = useAppSelector(selectCurrentPage);

  const handleClick = (elementName: string) => {
    if (onSettingsClick) {
      onSettingsClick(elementName);
    }
  };

  const previewDomain = selectedDomain || currentPage?.domain || 'https://my.example.com';
  const previewPath = selectedPath || '';

  return (
    <div className={clsx(className, 'flex h-full max-w-[280px] flex-col')}>
      <PanelTopHeader
        text="Page Settings"
        backButton={false}
        onClickClose={() => handleClick('')}
        className={''}
        saveBtnShow={false}
      />

      <ScrollArea className="flex w-full flex-1 overflow-hidden p-6">
        <div className="flex flex-col gap-2">
          <p className="text-button-sm font-medium text-neutral-900">SEO Preview</p>

          <div className="flex flex-col gap-0.5 rounded-md bg-neutral-50 p-2">
            <p className="text-button-sm max-w-full truncate font-medium text-indigo-500">
              {seoSettings?.seoPageTitle || currentPage?.name || 'My Landing Page'}
            </p>
            <p className="max-w-full truncate text-[10px] font-medium text-neutral-500">
              {'https://' + previewDomain + '/' + previewPath}
            </p>
            <p className="line-clamp-2 max-w-full text-[10px] font-medium text-neutral-500">
              {seoSettings?.seoPageDescription || 'Your description will appear here. Edit below.'}
            </p>
          </div>
        </div>

        <div className="mt-7 max-w-[232px] border-b border-neutral-100">
          <SettingsFavicon className="" onClick={() => {}} isOpenCollapse={false} />
          <SettingsSeo className="" onClick={() => {}} isOpenCollapse={false} />
          <SettingsSocial className="" onClick={() => {}} isOpenCollapse={false} />
          <SettingsScripts className="" onClick={() => {}} isOpenCollapse={false} />
        </div>
      </ScrollArea>
    </div>
  );
};
